import { css } from '@emotion/react';
import theme from '../../../../styles/theme';

export const styles = {
  wrapper: css`
    padding: 140px 80px 60px;
    background: #ffffff;

    @media (max-width: 980px) {
      padding: 120px 24px 40px;
    }
  `,

  top: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,

  label: css`
    font-size: 10px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: ${theme.palette.primary.main};
  `,

  line: css`
    width: 100%;
    height: 1px;
    background: ${theme.palette.primary.main};
    opacity: 0.6;
  `,

  content: css`
    margin-top: 32px;

    display: grid;
    grid-template-columns: 1fr 560px;
    column-gap: 48px;
    align-items: start;

    @media (max-width: 980px) {
      margin-top: 40px;
      grid-template-columns: 1fr;
      row-gap: 20px;
    }
  `,

  title: css`
    margin: 0;
    font-size: 45px;
    font-weight: 550;
    line-height: 1.05;
    letter-spacing: -1px;
    color: ${theme.palette.primary.main};

    @media (max-width: 980px) {
      font-size: 40px;
    }
  `,

  text: css`
    margin: 0;
    max-width: 620px;
    color: ${theme.palette.text.primary};
  `,
};
